export enum Operations {
    BLOCK = 'block',
    UNBLOCK = 'unblock',
    DELETE = 'delete',
}

export enum Status {
    BLOCKED = 'blocked',
    ACTIVE = 'active',
}

export enum NotificationType {
    INFO = 'info',
    ERROR = 'error',
    SUCCESS = 'success',
}

export enum LocalStorageValue {
    USER = 'user',
}
